import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row mr-3" }
const _hoisted_2 = { class: "demo-rich-conent" }

import { ExhibitionLayout } from "@/models/CardapioModel";
import { onMounted, ref} from "vue";
import { exhibitionLayout } from "@/services/CardapioService";
import { debounce } from "lodash";

interface ExhibitionLayoutPopover extends ExhibitionLayout {
  popover: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputLayout',
  props: {
    "exhibitionLayout": {},
    "exhibitionLayoutModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels(["update:modelValue"], ["update:exhibitionLayout"]),
  setup(__props, { emit: __emit }) {

const loading = ref(false)
const optionExhibitionLayout = ref<ExhibitionLayoutPopover[]>([]);
const modelValue = _useModel<string>(__props, "exhibitionLayout");

const getOptionExhibitionLayout = async () => {
  loading.value = true
  const response = await exhibitionLayout().finally(() => {
    loading.value = false
  })
  optionExhibitionLayout.value = response?.map((item) => {
    return {
      ...item,
      popover: true,
    };
  });
};

const emit = __emit;

const updateValue = (newValue: string) => {
  emit("update:modelValue", newValue);
}

const handleMouseOver = debounce((item: ExhibitionLayoutPopover) => {
  item.popover = true;
}, 200);

const handleMouseLeave = debounce((item: ExhibitionLayoutPopover) => {
  item.popover = false;
}, 200);

onMounted(() => {
  getOptionExhibitionLayout();
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_select, {
    class: "w-100",
    filterable: "",
    placeholder: "Escolha um layout",
    modelValue: modelValue.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      updateValue
    ]
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionExhibitionLayout.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.codCardapioGrupo,
          label: item.nome,
          value: item.imagem,
          onMouseenter: ($event: any) => (_unref(handleMouseOver)(item)),
          onMouseleave: ($event: any) => (_unref(handleMouseLeave)(item))
        }, {
          default: _withCtx(() => [
            (item.popover)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  class: "d-sm-none d-md-block",
                  width: 300,
                  trigger: "hover",
                  placement: "right",
                  "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px;"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("label", _hoisted_1, _toDisplayString(item.nome), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_image, {
                        shape: "square",
                        fit: "cover",
                        style: {"width":"270px","height":"132px"},
                        src: item.linkImagem
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["label", "value", "onMouseenter", "onMouseleave"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"])), [
    [_directive_loading, loading.value]
  ])
}
}

})